import { EyeIcon, EyeOffIcon } from './Icons';
import Logo from '../Logo';
import useLogin from '../../hooks/useLogin';
import './mobile.css';

export default function LoginMobile({ onLogin, showToast }) {
  const { email, setEmail, password, setPassword, showPassword, setShowPassword, loading, handleSubmit } =
    useLogin({ onLogin, showToast });

  return (
    <div className="mobile-page">
      <div className="mobile-header-spacer" />

      <div className="mobile-logo">
        <Logo size="large" center />
        <p className="mobile-logo-subtitle">Sprint board</p>
      </div>

      <form className="mobile-form" onSubmit={handleSubmit}>
        <div className="mobile-input-group">
          <label className="mobile-label">Email</label>
          <input
            className="mobile-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            autoComplete="email"
            required
            autoFocus
          />
        </div>

        <div className="mobile-input-group">
          <label className="mobile-label">Password</label>
          <div className="mobile-input-wrapper">
            <input
              className="mobile-input"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              className="mobile-input-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeOffIcon /> : <EyeIcon />}
            </button>
          </div>
        </div>

        <button
          type="submit"
          className="mobile-btn mobile-btn-primary"
          disabled={loading}
        >
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
      </form>
    </div>
  );
}
